<template>
  <div>
    <DataTable>
      <template #header>
        <span>License</span>
        <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      </template>
      <Column header="License Type"/>
      <Column header="License Number"/>
      <Column header="Issued Date"/>
      <Column header="Expiry Date"/>
      <Column header="Action"/>
    </DataTable>
    <Dialog header="License" :visible.sync="displayBasic" @show="setDate"
            :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
          <label for="licenseType">License Type<span style="color:red">*</span></label>
          <InputText v-model.trim="licenseType" id="licenseType"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="licenseNumber">License Number</label>
          <InputText v-model.trim="licenseNumber" id="licenseNumber"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="issueDate">Issued Date</label>
          <date-picker v-model="issuedDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="issueDate"
                     v-model="issuedDate"/>
        </div>
        <div class="p-field p-col-12 p-md-6">
          <label for="expireDate">Expiry Date</label>
          <date-picker v-model="expiryDate" valueType="format" v-if="!englishDateEnabled"/>
          <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="expireDate"
                     v-model="expiryDate"/>
        </div>
      </div>
      <template #footer>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <Button class="p-button-raised"
                    :label="!editing?'Add':'Update'"/>
            <Button class="p-button-raised p-button-info" v-if="!editing"
                    label="Add & New"/>
            <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import TextArea from 'primevue/textarea'
export default {
  name: 'license',
  data() {
    return {
      displayBasic: false,
      licenseType: '',
      licenseNumber: '',
      comments: '',
      issuedDate: null,
      expiryDate: null,
      editing: false,
      englishDateEnabled: true
    }
  },
  methods: {
    setDate() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.issuedDate = this.$store.getters.nepaliNewDate
        this.expiryDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.issuedDate = new Date().toISOString().slice(0, 10)
      this.expiryDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#issueDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.issuedDate = $('#issueDate').val()
        }
      })
      $('#expireDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        onChange: () => {
          this.expiryDate = $('#expireDate').val()
        }
      })
    },
    openBasic() {
      this.displayBasic = true
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    InputMask,
    DatePicker,
    TextArea
  }
}

</script>



// WEBPACK FOOTER //
// license.vue?be925610